import LogoutIcon from '@mui/icons-material/Logout';
import { Button } from '@mui/material';
import useAuth from 'features/auth/hooks/use-auth';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

const LogOutButton = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const onSignOut = () => {
    signOut();
    navigate(ROUTES.dynamic.signIn(undefined));
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      size="large"
      onClick={onSignOut}
      startIcon={<LogoutIcon />}
    >
      LOG OUT
    </Button>
  );
};
export default LogOutButton;
